import { createFileRoute } from '@tanstack/react-router';
import { effectivePermissionsScreen, loadProfileMessages, loadProfileScreens } from '@/modules/profile/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/meu-perfil/permissoes-efetivas/')({
  staticData: { screen: effectivePermissionsScreen },
  loader: () => loadProfileMessages(),
  component: lazyScreen(loadProfileScreens, 'EffectivePermissionsScreen'),
});
